import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleOutlinedSvg from "@ant-design/icons-svg/es/asn/DribbbleOutlined";
import AntdIcon from '../components/AntdIcon';
var DribbbleOutlined = function DribbbleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DribbbleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DribbbleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DribbbleOutlined';
}
export default RefIcon;